/* eslint-disable */ /* prettier-ignore */
<template>
  <div class="background-height pb-5 background">
    <div class="relative">
      <img
        class="rectangle-long-1 d-none d-md-block"
        src="https://res.cloudinary.com/oredev/image/upload/v1678562377/2023_web/temp/_69AFAB_-_So%CC%88k_pa%CC%8A_Google.png"
      />
      <img
        class="white-shape-1 d-none d-xl-block"
        src="https://res.cloudinary.com/oredev/image/upload/v1679424057/2023_web/shapes%20lp/white-shape-1.png"
      />
      <img
        class="white-shape-3 d-none d-xl-block"
        src="https://res.cloudinary.com/oredev/image/upload/v1679424057/2023_web/shapes%20lp/white-shape-3.png"
      />
      <img
        src="https://res.cloudinary.com/oredev/image/upload/v1679424058/2023_web/shapes%20lp/white-shape-5.png"
        class="d-none d-xl-block white-shape-5"
      />
      <img
        class="rectangle-long-6"
        src="https://res.cloudinary.com/oredev/image/upload/v1678533180/2023_web/temp/%C3%98redev_2023.png"
      />
      <img
        class="rectangle-long-7"
        src="https://res.cloudinary.com/oredev/image/upload/v1678533180/2023_web/temp/%C3%98redev_2023.png"
      />
      <img
        class="rectangle-long-8 d-none d-md-block"
        src="https://res.cloudinary.com/oredev/image/upload/v1678562377/2023_web/temp/_69AFAB_-_So%CC%88k_pa%CC%8A_Google.png"
      />
    </div>
    <b-container fluid>
      <b-row>
        <b-col sm="12" class="mt-5">
          <div class="d-flex justify-content-center align-items-center">
            <img
              class="fluid videoImage"
              src="https://res.cloudinary.com/oredev/image/upload/v1693925856/2023_web/HCF_image.png"
              alt=""
            />
          </div>
        </b-col>
      </b-row>
      <b-row no-gutters>
        <b-col>
          <div>
            <img
              class="rectangle-long-1-mobile d-block d-md-none"
              src="https://res.cloudinary.com/oredev/image/upload/v1678562377/2023_web/temp/_69AFAB_-_So%CC%88k_pa%CC%8A_Google.png"
            />
            <img
              class="rectangle-long-2 d-none d-md-block"
              src="https://res.cloudinary.com/oredev/image/upload/v1678533180/2023_web/temp/%C3%98redev_2023.png"
            />
            <img
              class="rectangle-long-3 d-none d-md-block"
              src="https://res.cloudinary.com/oredev/image/upload/v1678562377/2023_web/temp/_69AFAB_-_So%CC%88k_pa%CC%8A_Google.png"
            />

            <!-- <h1 class="hero-headline text-center">
              Øredev Developer Conference
            </h1> -->

            <div class="glitch">
              <div class="line hero-headline text-center">
                Øredev Developer Conference
              </div>
              <div class="line hero-headline text-center">
                Øredev Developer Conference
              </div>
              <div class="line hero-headline text-center">
                Øredev Developer Conference
              </div>
              <div class="line hero-headline text-center">
                Øredev Developer Conference
              </div>
              <div class="line hero-headline text-center">
                Øredev Developer Conference
              </div>
              <div class="line hero-headline text-center">
                Øredev Developer Conference
              </div>
              <div class="line hero-headline text-center">
                Øredev Developer Conference
              </div>
              <div class="line hero-headline text-center">
                Øredev Developer Conference
              </div>
              <div class="line hero-headline text-center">
                Øredev Developer Conference
              </div>
            </div>

            <h2 class="hero-headline-2 text-center">
              8-10 Nov 2023 – Malmö, Sweden
            </h2>
            <div class="d-flex justify-content-center">
              <router-link to="/tickets">
                <button
                  xmlns="http://www.w3.org/1999/xhtml"
                  class="btn btn-1 text-color-light mt-4"
                >
                  Tickets
                </button></router-link
              >
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import TopVue from "./Top.vue";

export default {
  components: {
    appTop: TopVue,
  },

  data() {
    return {
      isVisible: true,
    };
  },
  methods: {
    visibilityChanged(isVisible, entry) {
      this.isVisible = isVisible;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/variables.scss";

.background {
  color: black;
  background: url("https://res.cloudinary.com/oredev/image/upload/v1693925855/2023_web/Landing-page-latest.png");
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
}

@media screen and (min-width: 1400px) {
  .background {
    background: url("https://res.cloudinary.com/oredev/image/upload/v1693925855/2023_web/Landing-page-latest.png");
    background-repeat: no-repeat;
    background-position: top;
    background-size: cover;
    min-height: 140vh;
  }
}

@media screen and (max-width: 500px) {
  .background {
    background: url("https://res.cloudinary.com/oredev/image/upload/v1693925855/2023_web/Landing-page-latest.png");
    background-size: cover;
    background-position: bottom;
    background-repeat: no-repeat;
    min-height: 50vh;
  }
}

.hero-headline {
  width: 100%;
  font-size: 4rem;
  text-transform: uppercase;
  color: #292929;
}

@media screen and (max-width: 900px) {
  .hero-headline {
    font-size: 30px;
  }
}
@media screen and (max-width: 500px) {
  .hero-headline {
    font-size: 20px;
  }
}
.hero-headline-2 {
  width: 100%;
  color: black;
  font-size: 24px;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  font-weight: 700;
}

.videoImage {
  width: 60%;
  z-index: 20;
  margin-top: 190px;
}
@media screen and (max-width: 1000px) {
  .videoImage {
    margin-top: 90px;
  }
}
@media screen and (max-width: 600px) {
  .videoImage {
    width: 315px;
  }
}

.white-shape-1 {
  position: absolute;
  top: 75%;
  right: 0;
}
.white-shape-3 {
  position: absolute;
  top: 80%;
  right: 0%;
}

.rectangle-long-1 {
  width: 40%;
  height: 30px;
  position: absolute;
  top: 65%;
  right: 0;
  mix-blend-mode: color;
}
.rectangle-long-1-mobile {
  width: 70%;
  height: 15px;
  position: absolute;
  top: 42%;
  right: 0;
  mix-blend-mode: color;
  height: 12px;
}
.rectangle-long-2 {
  width: 90%;
  height: 30px;
  position: absolute;
  top: 15%;
  right: 0;
  mix-blend-mode: color;
}
.rectangle-long-2-mobile {
  width: 70%;
  height: 15px;
  position: absolute;
  top: 42%;
  right: 0;
  mix-blend-mode: color;
  height: 12px;
}

.rectangle-long-3 {
  width: 30%;
  height: 15px;
  position: absolute;
  top: 50%;
  right: 0;
  mix-blend-mode: color;
}
.rectangle-long-3-mobile {
  width: 30%;
  height: 15px;
  position: absolute;
  top: 42%;
  right: 0;
  mix-blend-mode: color;
  height: 12px;
}

.white-shape-5 {
  position: absolute;
  width: 37%;
  top: 77%;
  left: 0;
}

.rectangle-long-6 {
  width: 80%;
  height: 30px;
  mix-blend-mode: color;
  position: absolute;
  top: 15%;
  left: 0;
}
.rectangle-long-7 {
  width: 50%;
  height: 30px;
  mix-blend-mode: color;
  position: absolute;
  top: 70%;
  left: 0;
}
.rectangle-long-8 {
  width: 50%;
  height: 30px;
  mix-blend-mode: color;
  position: absolute;
  top: 60%;
  left: 0;
}

body {
  background-color: black;
  background-size: 10px 10px;
  height: 100vh;
  overflow: hidden;
  display: flex;
  font-family: "Barlow", sans-serif;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/TopLandingSection.vue